/**
 * Hosts que deben verse y comportarse como Haddock HR.
 * st-hr.haddock.app es el stage de Haddock, apuntando a nuestro pre.
 * PostHog no usa esta lista: solo corre en hr.haddock.app de producción.
 * Intercom (Plain) no se carga en estos hosts.
 * Zendesk tampoco va en el stage: solo en hr.haddock.app y haddock.local.
 */
export const HADDOCK_HOSTS = [
	"haddock.local",
	"hr.haddock.app",
	"st-hr.haddock.app",
];

export const HADDOCK_STAGE_HOST = "st-hr.haddock.app";

export const isHaddockHostname = (hostname) => HADDOCK_HOSTS.includes(hostname);

export const isHaddockStageHostname = (hostname) =>
	hostname === HADDOCK_STAGE_HOST;

export const isHaddockZendeskHostname = (hostname) =>
	isHaddockHostname(hostname) && !isHaddockStageHostname(hostname);
